<template>
  <div
    style="
      background: #2d2d2d;
      border-radius: 5px;
      padding: 5px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100% - 140px);
    "
    :style="`height: ${height};`">
    <div style="height: 100%; width: 100%">
      <video
        v-if="
          selected.value.toLowerCase().includes('.mp4') ||
          selected.value.toLowerCase().includes('.webm')
        "
        draggable="false"
        muted
        autoplay
        loop
        controls
        :src="
          state.devRedirect +
          state.$ident +
          '/api/download_asset?uid=' +
          selected.uid +
          '&token=' +
          auth
        "
        style="
          object-fit: contain;
          height: 100%;
          width: 100%;
          border-radius: 4px;
        "></video>
      <video
        v-else-if="selected.preview_motion_medium"
        draggable="false"
        muted
        autoplay
        loop
        controls
        :src="state.devRedirect + state.$ident + selected.preview_motion_medium"
        style="
          object-fit: contain;
          height: 100%;
          width: 100%;
          border-radius: 4px;
        "></video>
      <v-img
        v-else-if="is_img(selected.value)"
        :lazy-src="assetSmallThumbnail(selected)"
        loading="lazy"
        :src="
          state.devRedirect +
          state.$ident +
          '/api/download_asset?uid=' +
          selected.uid +
          '&token=' +
          auth
        "
        draggable="false"
        style="
          height: 100%;
          width: 100%;
          border-radius: 4px;
          background: #171717;
        ">
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              color="primary"
              indeterminate></v-progress-circular>
          </div>
        </template>
      </v-img>
      <v-img
        loading="lazy"
        v-else
        :src="assetSmallThumbnail(selected)"
        draggable="false"
        style="
          object-fit: contain;
          height: 100%;
          width: 100%;
          border-radius: 4px;
        " />
    </div>
  </div>
</template>
<script setup>
import { state } from '../../stores/deluge.js';
import { onMounted, ref } from 'vue';
import { assetSmallThumbnail } from '../../utils/thumbnails.js';
const auth = localStorage.getItem('authentication_token');
const props = defineProps(['selected', 'height']);
function is_img(str) {
  const img_formats = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.apng',
    '.svg',
    '.avif',
    '.webp',
  ];
  return new RegExp(img_formats.join('|')).test(str.toLowerCase());
}
</script>
